import {
  Avatar,
  Breakpoint,
  Dialog,
  DialogTitle,
  IconButton,
  PaperProps,
  // Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import images from "../../assets/images";

interface IDialogFormProps {
  scroll?: "body" | "paper";
  maxWidth?: Breakpoint | false;
  openDialog: boolean;
  // disableEnforceFocus: boolean;
  // disableAutoFocus: boolean;
  title?: any;
  className?: string;
  bgColor?: string;
  color?: string;
  bodyContent?: React.ReactNode;
  paperProps?: Partial<PaperProps>;
  handleDialogClose: () => void;
}

const DialogForm: React.FC<IDialogFormProps> = ({
  scroll,
  maxWidth,
  openDialog,
  handleDialogClose,
  title,
  className,
  bodyContent,
  paperProps,
  bgColor,
  color
  // disableEnforceFocus,
  // disableAutoFocus
}) => {

  const backdropRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (backdropRef.current) {
      if (openDialog) {
        backdropRef.current.setAttribute('inert', '');
      } else {
        backdropRef.current.removeAttribute('inert');
      }
    }
  }, [openDialog]);
  // console.log(title,42)
  return (
    <Dialog
      open={openDialog}
      // onClose={handleDialogClose}
      // id = {"#green-back"}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleDialogClose();
        }
      }}
      className={`${className}`}
      scroll={scroll}
      maxWidth={maxWidth}
      PaperProps={paperProps}
      disableAutoFocus
      disableEnforceFocus
      BackdropProps={{
        ref: backdropRef,
      }}
    >

      {title && (
        <DialogTitle id="font-600" sx={{ backgroundColor: bgColor ? bgColor : "#382DAE", 
        color: color ? color :"#ffffff" }}>
        {/* color: color ? color :"#000" }}> */}
          {/* <Typography>{title}</Typography> */}
          {title}
          <IconButton
            size="small"
            className="close-action"
            onClick={handleDialogClose}

          >
            <Avatar sx={{ width: 22, height: 22 }} 
            style={{color:"#000"}}
            src={images.CloseWhite} />
          </IconButton>
        </DialogTitle>
      )}
      {bodyContent}
    </Dialog>
  );
};

export default DialogForm;
